import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import store from "./store/store";
import App from "./App";
import "./index.css";
// Loaded after index.css so the dark remap sits below the Tailwind utilities it
// overrides. Inert until <html> gets the `dark` class - see contexts/ThemeContext.
import "./styles/theme-dark.css";
import reportWebVitals from "./reportWebVitals";

// Error tracking. Initialised only when a DSN is configured and we're running a
// production build, so local development never ships to the shared Sentry
// project (mirrors the backend's Heroku-only gate). Leave REACT_APP_SENTRY_DSN
// empty to keep the SDK inert.
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn && process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Disable console logs in production
if (process.env.NODE_ENV === "production") {
  console.log = function () {};
  console.warn = function () {};
  console.error = function () {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// TEMPORARY: Disable StrictMode completely to prevent duplicate API calls
// StrictMode causes double-rendering in development which overwhelms the backend
// TODO: Re-enable StrictMode after optimizing all useEffect dependencies
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
